import styled from "styled-components";
import { Button } from "@assistansbolaget/gat-components";

const CallButton = styled(Button)``;

export default CallButton;
